// extracted by mini-css-extract-plugin
export var searchHeader = "_6x-0";
export var searchHeaderDark = "_6x-1";